module.exports = __webpack_public_path__ + "static/me@2x.62953a06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/me@2x.jpg
// module id = 304
// module chunks = 35783957827783